














import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
import AsiTextField from "@/components/common/AsiTextField";
import AsiRadioGroup from "@/components/common/AsiRadioGroup";
import AsiTextarea from "@/components/common/AsiTextarea";
import User from "@/models/user/User";
import {SnackbarMessage} from "@/models/SnackbarMessage";
import {ValidationRule} from "@/declarations/ValidationRule";
import AsiBtn from "@/components/common/AsiBtn.vue";
import UserRules from "@/models/user/UserRules";

@Component({
	components: {AsiBtn, AsiTextarea, AsiRadioGroup, AsiTextField, AsiDialogFormLayout}
})
export default class UserUpdateDialogPassword extends AsiDialogForm {

	@Prop({type: Object, required: true})
	public user!: User;

	private visible: boolean = false;
	private password: string | null = null;

	// noinspection JSMethodCanBeStatic
	private get passwordRules(): ValidationRule[] {
		return UserRules.passwordRules;
	}

	private get inputType(): string {
		return this.visible ? 'text' : 'password';
	}

	@Emit('save')
	public save(event: Event): Event {
		return event;
	}

	@Emit('cancel')
	public cancel(event: Event): Event {
		const form = this.$refs.form as HTMLFormElement;
		this.reset([], form);
		this.password = null;
		this.visible = false;
		return event;
	}

	private toggleVisibility(): void {
		this.visible = !this.visible;
	}

	@Watch('user', {deep: true})
	private onUserChanged(): void {
		this.password = null;
	}

	private requestSave(event: Event): void {
		if (this.password === null) return;

		this.loading = true;
		this.$userService.updatePassword(this.user.id, this.password)
			.then(() => this.save(event))
			.catch(() => {
				this.$store.commit('ui/showSnackbar', {
					message: this.$t('snackbar.updateError'),
					color: 'error',
				} as SnackbarMessage);
			})
			.finally(() => {
				this.loading = false;
			});
	}

}
